import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { API_ADDRESS, httpOptionsDefault } from "../constants";
import { BoletoItauController } from "./BoletoItauController";
import { BoletoInterController } from "./BoletoInterController";
import { BuyController } from "./buyController";
import { ChargerController } from "./chargerController";
import { CieloController } from "./cieloController";
import { MercadoPagoController } from "./mercadopagoController";
import { PurchasesController } from "./purchaseController";
import { ViaCepController } from "./viaCepController";
import { ReportsController } from "./ReportsController";
import { AsaasController } from "./asaasController";
import { CustomersController } from "./CustomersController";
import { LicensesController } from "./LicensesController";

@Injectable()
export class ControllersService {
  
  
    getLicenses() {
    return new LicensesController(this._http);
  }
  getReports() {
    return new ReportsController(this._http);
  }


  getMercadoPago() {
      return new MercadoPagoController(this._http);
  }


  getCielo() {
    return new CieloController(this._http);
  }
 
  getAsaas() {
    return new AsaasController(this._http);
  }
 
  
  getBoletoItau() {
    return new BoletoItauController(this._http);
  }

  getBoletoInter() {
    return new BoletoInterController(this._http);
  }


    getBuy() {
        return new BuyController(this._http);
  }


  getViaCep() {
    return new ViaCepController(this._http);
}
getCharger() {
    return new ChargerController(this._http);
}


  getCustomers() {
    return new CustomersController(this._http);
  }
 
    constructor(public _http: HttpClient) {

    }
    getCrypto(): CryptoController {
        return new CryptoController(this._http);
    }

   getPurchases() {
         return new PurchasesController(this._http);
    }

  
 
      
}



export class CryptoController {

    constructor(public _http: HttpClient) {

    }
    decrypt(text: string): Promise<string> {

        console.log(API_ADDRESS + `/crypto/decrypt`);

        return this._http.post(API_ADDRESS + `/crypto/decrypt`, { value: text }, httpOptionsDefault)
            .pipe(
                map(result => {


                    return result;
                }

                ),
                catchError(error => {

                    return error;
                })
            )
            .toPromise().then((result: any) => {


                return result.value;
            });

    }

    encrypt(text: string): Promise<string> {
        return this._http.get(API_ADDRESS + `/crypto/encrypt/${text}`, httpOptionsDefault)
            .pipe(
                map(result => {


                    return result;
                }

                ),
                catchError(error => {

                    return error;
                })
            )
            .toPromise().then((result: any) => {


                return result.value;
            });
    }

}
